
import { Component, Vue } from 'vue-property-decorator'
import { questionPage } from '@/api'
import { QuestionPageParam } from '@/types/type'
@Component({
    name: 'VideoList'
})
export default class extends Vue {
    private keyWord = this.$route.query.keyWord as string || ''
    private questionParams = new QuestionPageParam()
    private total: number = 0
    // 详情
    private goDetail(id: string) {
        this.$jump(`/Question/QuestionDetail?questionId=${id}`)
    }
    private editData = []
    private async getBaseSearch() {
        this.questionParams.title = this.keyWord
        let res = await questionPage(this.questionParams)
        this.editData = res.data.list
        this.total = res.data.total
    }
    private handlePageChange(page: any) {
        this.questionParams.pageNum = page.pageNo
        this.getBaseSearch()
    }
    created() {
        this.getBaseSearch()
    }
}

